// The EMPTY state of a home widget (HOME_WIDGETS_SPEC.md §2): a DESIGNED
// empty state, never "0", "0.00" or a large card holding one lone line (the
// peer's qa round 9: the Stores widget with no sales in the period). Centred in
// the card:
//   • the widget's own icon on a quiet `layer` disc, in the widget hue — not at
//     S, where a small card keeps its words;
//   • ONE sentence (`A` 500 `title`, balanced);
//   • ONE next action: the body's own (record a sale, add a contact …), else
//     the widget's app — "Open <widget>", the same open as the card and its ↗
//     (functions/homeWidgetFrame.js homeWidgetOpen) — and none when the widget
//     has nowhere to go.
// The plate and the title stay. The BODY decides when it shows: `empty` on the
// body root (components/HomeWidgetBody.js) swaps every data slot for this
// block; without it the block stays hidden.
//
//   HomeWidgetEmpty: {
//     Text: { text: '{{ apps.widget.storeRevenueToday.emptySentence | polyglot }}' },
//     Action: { text: '{{ apps.widget.storeRevenueToday.recordSale | polyglot }}', onClick: … }
//   }
//
// Both actions are the kit's quiet control (`layer` wash, `title` ink, hover
// `selected`), the same pair EmptyState uses for its secondary action.
export const HomeWidgetEmpty = {
  class: 'home-widget-empty',
  gridArea: '1 / 1 / -1 / -1',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: 'Z',
  minWidth: '0',

  Glyph: {
    tag: 'span',
    ariaHidden: 'true',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: '0',
    boxSize: 'avatarMd',
    round: 'radiusPill',
    theme: 'layer',
    ':is([data-widget-size="s"]) &': { display: 'none' },
    Icon: {
      name: (el, s) => (s && s.icon) || 'star',
      boxSize: 'iconLg',
      color: '--home-widget-accent'
    }
  },

  Text: {
    tag: 'p',
    margin: '0',
    maxWidth: '100%',
    fontSize: 'A',
    fontWeight: '500',
    lineHeight: '1.35',
    color: 'title',
    overflowWrap: 'anywhere',
    textWrap: 'balance'
  },

  Action: {
    extends: 'AppControl',
    compact: true,
    tag: 'button',
    type: 'button',
    theme: 'layer',
    color: 'title',
    padding: '0 A',
    round: 'radiusPill',
    fontSize: 'Z2',
    fontWeight: '500',
    border: 'none',
    cursor: 'pointer',
    ':hover': { background: 'selected' },
    ':active': { background: 'selected' },
    hide: (el) => !el.call('homeSlotText', el)
  },

  Open: {
    extends: 'AppControl',
    compact: true,
    tag: 'button',
    type: 'button',
    theme: 'layer',
    color: 'title',
    padding: '0 A',
    round: 'radiusPill',
    fontSize: 'Z2',
    fontWeight: '500',
    border: 'none',
    cursor: 'pointer',
    ':hover': { background: 'selected' },
    ':active': { background: 'selected' },
    text: (el, s) =>
      String(el.call('polyglot', 'workspace.menu.openApp')).replace(
        '{app}',
        String(el.call('polyglot', (s && (s.title || s.id)) || ''))
      ),
    hide: (el, s) =>
      !!el.call('homeSlotText', el.parent.Action) || !el.call('homeWidgetOpenRoute', s),
    onClick: (e, el, s) => {
      e.stopPropagation()
      el.call('homeWidgetOpen', s, e)
    }
  }
}
